var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"r-list-item"},[_c('p',{staticClass:"r-list-item--content"},[_vm._t("default")],2),_c('p',{staticClass:"r-list-item--caption"},[_vm._v(_vm._s(_vm.caption))])])
}
var staticRenderFns = []

export { render, staticRenderFns }